import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../containers/SwitchWithNotFound';
import { NotFoundView } from '../views/errors/NotFound.view';
import { AnnotationCreateView } from '../views/home/annotations/AnnotationCreate.view';
import { AnnotationReviewView } from '../views/home/annotations/AnnotationReview.view';
import { Home } from './config/Home';

export const AnnotationsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Annotations.Create.Path}>
      <AnnotationCreateView />
    </Route>
    <Route path={Home.Annotations.Review.Path}>
      <AnnotationReviewView />
    </Route>
  </SwitchWithNotFound>
);
